import { useRef, useCallback } from 'react';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var isEventValid = function isEventValid(event) {
  var VALID_PROD_ORIGIN = /^https:\/\/[a-zA-Z0-9-.]+\.mercadoli[vb]re\.(?:com\.(?:ar|br|co|mx|uy|pe|ec|ve)|cl)$/;
  var VALID_DEV_ORIGIN = /^https:\/\/[a-zA-Z0-9-.]+\.mercadoli[vb]re\.(?:com\.(?:ar|br|co|mx|uy|pe|ec|ve)|cl):8444/;
  var VALID_DEV_PARENT = /^https:\/\/[a-zA-Z0-9-.]+\.mercadoli[vb]re\.(?:com\.(?:ar|br|co|mx|uy|pe|ec|ve)|cl):844[36]/;
  var matchs = function matchs(origin, pattern) {
    return origin.search(pattern) !== -1;
  };
  var isDevEnvironment = function isDevEnvironment() {
    return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' ? matchs(window.location.href, VALID_DEV_PARENT) : false;
  };
  var isValidData = function isValidData(data) {
    return !!data;
  };
  var isValidOriginOnProd = function isValidOriginOnProd(origin) {
    return matchs(origin, VALID_PROD_ORIGIN);
  };
  var isValidOriginOnDev = function isValidOriginOnDev(origin) {
    if (matchs(origin, VALID_DEV_ORIGIN)) {
      return true;
    }
    return false;
  };
  var isValidOrigin = function isValidOrigin(data, origin) {
    if (isDevEnvironment()) {
      return isValidOriginOnDev(origin);
    }
    return isValidOriginOnProd(origin);
  };
  var data = event.data,
    _event$origin = event.origin,
    origin = _event$origin === void 0 ? '' : _event$origin;
  return isValidData(data) && isValidOrigin(data, origin);
};
var isEventValid$1 = isEventValid;
var CHANNEL_REAL_TIME = 'real-time-channel';
var MESSAGE_TYPE_HOVER = 'SECTION_HOVER';
var MESSAGE_TYPE_UPDATE_PROPERTIES = 'UPDATE_COMPONENT_PROPERTIES';
var THEME_MANAGER_COMPONENT_ID = 'theme-manager';
var MESSAGE_TYPE_COLOR = 'UPDATE_COLOR';
var MESSAGE_TYPE_TYPOGRAPHIES = 'UPDATE_TYPOGRAPHIES';
var EDITOR_IFRAME_QUERY_SELECTOR = 'iframe.editor';
var useMessage = function useMessage() {
  var ref = useRef(null);
  var handlerDecorator = useCallback(function (handler) {
    return function (event) {
      if (!isEventValid$1(event)) {
        return;
      }
      var _event$data = event.data,
        channelId = _event$data.channelId,
        componentId = _event$data.componentId,
        action = _event$data.action,
        payload = _event$data.payload,
        coords = _event$data.coords;
      if (channelId === CHANNEL_REAL_TIME) {
        handler(componentId, action, payload, coords);
      }
    };
  }, []);
  var unsubscribe = useCallback(function () {
    if (ref.current) {
      window.removeEventListener('message', ref.current);
      ref.current = null;
    }
  }, []);
  var subscribe = useCallback(function (handler) {
    if (ref.current) {
      unsubscribe(ref.current);
    }
    ref.current = handlerDecorator(handler);
    window.addEventListener('message', ref.current, false);
  }, []);
  var emit = useCallback(function (componentId, action, payload, coords) {
    window.parent.postMessage({
      channelId: CHANNEL_REAL_TIME,
      componentId: componentId,
      action: action,
      payload: payload,
      coords: coords
    }, '*');
  }, []);
  var broadcast = useCallback(function (componentId, action, payload, coords) {
    var _document$querySelect;
    var iframeNode = (_document$querySelect = document.querySelector(EDITOR_IFRAME_QUERY_SELECTOR)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.contentWindow;
    if (!iframeNode) {
      return;
    }
    iframeNode.postMessage({
      channelId: CHANNEL_REAL_TIME,
      componentId: componentId,
      action: action,
      payload: payload,
      coords: coords
    }, '*');
  }, []);
  return {
    subscribe: subscribe,
    unsubscribe: unsubscribe,
    emit: emit,
    broadcast: broadcast
  };
};
var useMessage$1 = useMessage;
var useRealTimeHover = function useRealTimeHover(componentId) {
  var _useMessage = useMessage$1(),
    subscribe = _useMessage.subscribe,
    unsubscribe = _useMessage.unsubscribe,
    emit = _useMessage.emit,
    broadcast = _useMessage.broadcast;
  var handlerDecorator = useCallback(function (handler) {
    return function (updatedComponentId, action, payload) {
      if (action === MESSAGE_TYPE_HOVER && componentId === updatedComponentId) {
        handler(payload.hovered);
      }
    };
  }, [componentId]);
  var subscribeToHover = useCallback(function (handler) {
    subscribe(handlerDecorator(handler));
  }, []);
  var unsubscribeToHover = useCallback(function () {
    unsubscribe();
  }, []);
  var emitHover = useCallback(function (hovered) {
    emit(componentId, MESSAGE_TYPE_HOVER, {
      hovered: hovered
    });
  }, [componentId]);
  var broadcastHover = useCallback(function (hovered) {
    broadcast(componentId, MESSAGE_TYPE_HOVER, {
      hovered: hovered
    });
  }, [componentId]);
  return {
    subscribeToHover: subscribeToHover,
    unsubscribeToHover: unsubscribeToHover,
    emitHover: emitHover,
    broadcastHover: broadcastHover
  };
};
var useRealTimeHover$1 = useRealTimeHover;
var useRealTimeProperties = function useRealTimeProperties(componentId) {
  var _useMessage = useMessage$1(),
    subscribe = _useMessage.subscribe,
    unsubscribe = _useMessage.unsubscribe,
    emit = _useMessage.emit,
    broadcast = _useMessage.broadcast;
  var handlerDecorator = useCallback(function (handler) {
    return function (updatedComponentId, scope, payload) {
      if (scope === MESSAGE_TYPE_UPDATE_PROPERTIES && componentId === updatedComponentId) {
        handler(payload);
      }
    };
  }, [componentId]);
  var subscribeToUpdateProperties = useCallback(function (handler) {
    subscribe(handlerDecorator(handler));
  }, []);
  var unsubscribeToUpdateProperties = useCallback(function () {
    unsubscribe();
  }, []);
  var emitUpdateProperties = useCallback(function (properties) {
    emit(componentId, MESSAGE_TYPE_UPDATE_PROPERTIES, properties);
  }, [componentId]);
  var broadcastUpdateProperties = useCallback(function (properties) {
    broadcast(componentId, MESSAGE_TYPE_UPDATE_PROPERTIES, properties);
  }, [componentId]);
  return {
    subscribeToUpdateProperties: subscribeToUpdateProperties,
    unsubscribeToUpdateProperties: unsubscribeToUpdateProperties,
    emitUpdateProperties: emitUpdateProperties,
    broadcastUpdateProperties: broadcastUpdateProperties
  };
};
var useRealTimeProperties$1 = useRealTimeProperties;
var useRealTimeColors = function useRealTimeColors() {
  var _useMessage = useMessage$1(),
    subscribe = _useMessage.subscribe,
    unsubscribe = _useMessage.unsubscribe,
    emit = _useMessage.emit,
    broadcast = _useMessage.broadcast;
  var colorHandlerDecorator = useCallback(function (handler) {
    return function (_, action, payload) {
      if (action === MESSAGE_TYPE_COLOR) {
        handler(payload);
      }
    };
  }, []);
  var subscribeToColor = useCallback(function (handler) {
    subscribe(colorHandlerDecorator(handler));
  }, []);
  var unsubscribeToColor = useCallback(function () {
    unsubscribe();
  }, []);
  var emitColor = useCallback(function (styleConfig) {
    emit(THEME_MANAGER_COMPONENT_ID, MESSAGE_TYPE_COLOR, {
      styleConfig: styleConfig
    });
  }, []);
  var broadcastColor = useCallback(function (styleConfig) {
    broadcast(THEME_MANAGER_COMPONENT_ID, MESSAGE_TYPE_COLOR, {
      styleConfig: styleConfig
    });
  }, []);
  return {
    subscribeToColor: subscribeToColor,
    unsubscribeToColor: unsubscribeToColor,
    emitColor: emitColor,
    broadcastColor: broadcastColor
  };
};
var useRealTimeColors$1 = useRealTimeColors;
var useRealTimeTypographies = function useRealTimeTypographies() {
  var _useMessage = useMessage$1(),
    subscribe = _useMessage.subscribe,
    unsubscribe = _useMessage.unsubscribe,
    emit = _useMessage.emit,
    broadcast = _useMessage.broadcast;
  var typographiesHandlerDecorator = useCallback(function (handler) {
    return function (_, action, payload) {
      if (action === MESSAGE_TYPE_TYPOGRAPHIES) {
        handler(payload);
      }
    };
  }, []);
  var subscribeToTypographies = useCallback(function (handler) {
    subscribe(typographiesHandlerDecorator(handler));
  }, []);
  var unsubscribeToTypographies = useCallback(function () {
    unsubscribe();
  }, []);
  var emitTypographies = useCallback(function (styleConfig) {
    emit(THEME_MANAGER_COMPONENT_ID, MESSAGE_TYPE_TYPOGRAPHIES, {
      styleConfig: styleConfig
    });
  }, []);
  var broadcastTypographies = useCallback(function (styleConfig) {
    broadcast(THEME_MANAGER_COMPONENT_ID, MESSAGE_TYPE_TYPOGRAPHIES, {
      styleConfig: styleConfig
    });
  }, []);
  return {
    subscribeToTypographies: subscribeToTypographies,
    unsubscribeToTypographies: unsubscribeToTypographies,
    emitTypographies: emitTypographies,
    broadcastTypographies: broadcastTypographies
  };
};
var useRealTimeTypographies$1 = useRealTimeTypographies;
export { useMessage$1 as useMessage, useRealTimeColors$1 as useRealTimeColors, useRealTimeHover$1 as useRealTimeHover, useRealTimeProperties$1 as useRealTimeProperties, useRealTimeTypographies$1 as useRealTimeTypographies };
